module.exports = __webpack_public_path__ + "img/LTE.9451d621.svg";